import styled from '@emotion/styled/macro';

export const FormEmptyField = styled.div`
  width: 100%;
`;
